/**
 * Runs a callback in a new task after the browser's next paint, so work that
 * does not change what the user sees (analytics, logging) stays out of an
 * interaction's INP. A requestAnimationFrame callback runs just before the
 * paint; the timeout queued from it runs after.
 *
 * Hidden tabs don't run animation frames, so a tab that is already hidden
 * skips the wait, and one hidden before the frame runs the callback straight
 * away: it may be about to close.
 */
const runAfterNextPaint = callback => {
  if (typeof window === 'undefined') {
    return;
  }

  let hasRun = false;

  const run = () => {
    if (hasRun) {
      return;
    }
    hasRun = true;
    callback();
  };

  const onVisibilityChange = () => {
    if (document.visibilityState === 'hidden') {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      run();
    }
  };

  if (
    typeof window.requestAnimationFrame !== 'function' ||
    document.visibilityState === 'hidden'
  ) {
    setTimeout(run, 0);
    return;
  }

  document.addEventListener('visibilitychange', onVisibilityChange);

  window.requestAnimationFrame(() => {
    setTimeout(() => {
      document.removeEventListener('visibilitychange', onVisibilityChange);
      run();
    }, 0);
  });
};

export default runAfterNextPaint;
